import { useMemo } from 'react';

import { PortfolioTypes } from '~/models/PortfolioType';
import { PaymentMethod } from '~/networking';

import { useAllPaymentMethods } from './useAllPaymentMethods';
import { useAuthentication } from '~/hooks/useAuthentication';

export const useDepositDestinationValues = (destinationPortfolio: PortfolioTypes) => {
    const { managed, wine, trading, whiskey } = useAllPaymentMethods();
    const { userId } = useAuthentication(false);

    const refetchPaymentMethods = (): void => {
        managed.refetch();
        wine.refetch();
        trading.refetch();
        whiskey.refetch();
    };

    const savedPaymentMethods = useMemo(() => {
        switch (destinationPortfolio) {
            case PortfolioTypes.managed:
                return managed?.payments ?? [];
            case PortfolioTypes.wine:
                return wine?.payments ?? [];
            case PortfolioTypes.trading:
                return trading?.payments ?? [];
            case PortfolioTypes.whiskey:
                return whiskey?.payments ?? [];
            default:
                return [] as unknown as PaymentMethod[];
        }
    }, [destinationPortfolio, managed.payments, wine.payments, trading.payments, whiskey.payments]);

    const destinationPortfolioId = useMemo(() => {
        if (!userId) {
            return '';
        }
        switch (destinationPortfolio) {
            case PortfolioTypes.managed:
                return userId;
            case PortfolioTypes.trading:
                return `tp_${userId}`;
            case PortfolioTypes.wine:
                return userId;
            case PortfolioTypes.whiskey:
                // special for the deposit flow, we're using this to indicate whiskey intent
                return `wp_${userId}`;
            default:
                return '';
        }
    }, [userId, destinationPortfolio]);

    return {
        savedPaymentMethods,
        refetchPaymentMethods,
        destinationPortfolioId,
        paymentMethodsLoaded: managed.isSuccess && wine.isSuccess && trading.isSuccess && whiskey.isSuccess
    };
};
